import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  ResolveFn,
  RouterStateSnapshot,
  TitleStrategy,
} from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { TitleTranslation } from '@core/types/title.translation';

export const titleWithParams =
  (
    fn: (route: ActivatedRouteSnapshot) => TitleTranslation,
  ): ResolveFn<string> =>
  (route) =>
    JSON.stringify(fn(route));

@Injectable()
export class TranslatedTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);
  private readonly translate = inject(TranslateService);

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const raw = this.buildTitle(snapshot);

    if (!raw) {
      this.translate
        .get('APP.TITLE')
        .subscribe((text: string) => this.title.setTitle(text));
      return;
    }

    const resolved = this.parseTitle(raw);
    const key = typeof resolved === 'string' ? resolved : resolved.key;
    const params = typeof resolved === 'object' ? resolved.params : undefined;

    this.translate
      .get(key, params)
      .subscribe((text) => this.title.setTitle(text));
  }

  private parseTitle(raw: string): TitleTranslation {
    try {
      const parsed: unknown = JSON.parse(raw);
      if (typeof parsed === 'object' && parsed !== null && 'key' in parsed) {
        return parsed as TitleTranslation;
      }
    } catch {
      // not JSON, treat as plain translation key
    }
    return raw;
  }
}
